import * as React from "react";
import classnames from "classnames";
import { upperFirst } from "lodash";

import { iInteractiveComponentProps } from "@/interfaces/ui";
import { iPaymentCard } from "@/interfaces/payments";

import { Button } from "@/components/content";

interface iProps extends iInteractiveComponentProps {
  /**
   * Optionally customise the brand image url.
   */
  getBrandImageSrc?: (card: iPaymentCard) => string;
  /**
   * The card info.
   */
  card: iPaymentCard;
  /**
   * Prop will be called when the user clicks on the container.
   */
  onClick?: () => any;
  /**
   * A delete button will be displayed if provided.
   * Prop will be called when the button is clicked.
   */
  onDelete?: () => any;
}

export const PaymentCard: React.SFC<iProps> = (props: iProps) => {
  const className = classnames("payment-card", {
    "payment-card--interactive": !!props.onClick,
    "payment-card--status-disabled": props.disabled,
    "payment-card--status-selected": props.selected,
  });

  const clickHandler = () => {
    props.onClick();
  };

  const deleteHandler = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    props.onDelete();
  };

  return (
    <div className={className} onClick={clickHandler}>
      <div className="payment-card__brand">
        <span className="payment-card__brand-name">
          {upperFirst(props.card.brand)}
        </span>
        <img
          alt={`${props.card.brand} logo`}
          className="payment-card__brand-image"
          src={props.getBrandImageSrc(props.card)}
        />
      </div>
      <span className="payment-card__name">{upperFirst(props.card.name)}</span>
      <div className="payment-card__numbers">
        <span className="payment-card__number-group">••••</span>
        <span className="payment-card__number-group">••••</span>
        <span className="payment-card__number-group">••••</span>
        <span className="payment-card__number-group">
          {props.card.last_four}
        </span>
      </div>
      {props.onDelete ? (
        <Button
          className="btn-c2a style-danger payment-card__delete"
          disabled={props.disabled}
          onClick={deleteHandler}
          size="small"
          theme="danger"
        >
          Delete Card
        </Button>
      ) : null}
    </div>
  );
};
PaymentCard.defaultProps = {
  getBrandImageSrc: (card: iPaymentCard) =>
    `/img/card_types/${card.brand.toLowerCase()}.png`,
  onClick: () => null,
};
PaymentCard.displayName = "PaymentCard";
